import React from "react";
import Input from "./Input";
class DateTimePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value ? this.props.value :""
        }
        this.onDatePickerChange = this.onDatePickerChange.bind(this);
    }
    onDatePickerChange(value) {
        this.props.onChange(value);
        this.setState({ value });
    }
    render() {
        var { onChange, value, ...newProps } = this.props;
        return (
            <Input type="datetime-local" onChange={this.onDatePickerChange} value={this.state.value} {...newProps} />
        )
    }
}

export default DateTimePicker;